import { useEffect, useEffectEvent } from "react";
import type { FormikErrors, FormikTouched } from "formik";
import { getFormikErrorsRecursive } from "../validation";
import { useSnackbar } from "../context/SnackbarContext";

type Props<T> = {
  disabled?: boolean;
  errors: FormikErrors<T>;
  touched: FormikTouched<T>;
};

export function useSnackbarFormikErrors<T>({
  disabled,
  errors,
  touched,
}: Props<T>) {
  const showSnackbar = useSnackbar();

  const showError = useEffectEvent((errors: FormikErrors<T>) => {
    if (disabled) return;

    const error = getFormikErrorsRecursive(errors, touched)[0];

    if (error) {
      showSnackbar({
        content: error,
      });
    }
  });

  useEffect(() => {
    showError(errors);
  }, [errors]);
}
